/* istanbul ignore next */
const sleep = (duration) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, duration);
    });
};
export const AsyncUtils = { sleep };
